// +----------------------------------------------------------------------
// | 决策因素列表 + 权重调节（中等问题的「你现在更在乎」滑动条）
// +----------------------------------------------------------------------
import { weightToWidth } from '../../lib/format';
import './FactorList.less';

export default function FactorList({ factors = [], onChange, disabled = false }) {
  if (!factors.length) return null;

  return (
    <div className="factor-list">
      {factors.map((factor) => {
        const width = weightToWidth(factor.weight);
        return (
          <div className="factor-item" key={factor.id || factor.name}>
            <div className="factor-item-head">
              <span className="factor-item-name">{factor.name}</span>
              <span className="factor-item-weight">{width}%</span>
            </div>

            <div className="factor-item-track">
              <div className="factor-item-bar" style={{ width: `${width}%` }} />
              <input
                type="range"
                min="0"
                max="1"
                step="0.05"
                value={factor.weight > 1 ? factor.weight / 100 : factor.weight}
                disabled={disabled}
                onChange={(e) => onChange && onChange(factor, Number(e.target.value))}
              />
            </div>

            {factor.source === 'ai' && <span className="factor-item-source">AI 判断</span>}
          </div>
        );
      })}
    </div>
  );
}
